import '../chart_view.js.coffee'

Namespace 'Monitoring.Views.Charts'

class Monitoring.Views.Charts.WordsRankingCalculator extends Backbone.View

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facets = @options.facets
    @responseByJobName = {}
    @enqueuedByJobName = {}

  calculate: (jobName, ngramsLimit) ->
    if @responseByJobName[jobName]
      @trigger("calculate_#{jobName}", @responseByJobName[jobName])
      false
    else if !@enqueuedByJobName[jobName]
      @enqueuedByJobName[jobName] = true
      job = new Monitoring.Methods.AsyncJob()
      job.bind('completed', (response) =>
        @onComplete(jobName, response)
      )
      job.bind('failed', () => @onFailed(jobName))
      job.start(jobName, _.extend({ngrams_limit: ngramsLimit}, @searchQuery.attributes))
      job

  onComplete: (jobName, response) =>
    @responseByJobName[jobName] = response
    @trigger("calculate_#{jobName}", @responseByJobName[jobName])

  onFailed: (jobName) =>
    delete @enqueuedByJobName[jobName]
